export const trainingCardStyles = {
  coverImage: 'h-full w-full object-cover',
  shell:
    'flex w-full flex-col gap-4 bg-white am-3xl:min-h-52 am-3xl:gap-0 am-3xl:flex-col am-3xl:overflow-hidden am-3xl:rounded-2xl am-3xl:border am-3xl:border-plum-200',
  mobileTopRule: '-mx-4 shrink-0 border-t border-teal-300 am-3xl:hidden',
  mainRow: 'flex min-h-0 flex-1 flex-col px-0 am-3xl:h-full am-3xl:flex-row am-3xl:flex-nowrap',
  desktopImageAside:
    'hidden min-h-0 w-2/5 shrink-0 self-stretch overflow-hidden bg-gray-900 am-3xl:block',
  bodyColumn:
    'flex min-h-0 flex-1 flex-col gap-4 am-3xl:grow am-3xl:h-full am-3xl:px-6 am-3xl:pb-6 am-3xl:pt-4',
  tagsRow: 'flex min-w-0 w-full items-center gap-3',
  tagsRowSpacer: 'min-h-0 min-w-0 flex-1 shrink basis-0',
  monthBadge:
    'inline-flex items-center justify-center gap-2 rounded-tl-none rounded-tr rounded-br rounded-bl bg-plum-100 px-2 py-1 capitalize text-denim-500 text-sm font-medium leading-4',
  categoryLine: 'inline-flex items-center gap-2 text-xs font-medium leading-4',
  glyph: 'size-4 shrink-0',
  metaGlyph: 'size-4 shrink-0 text-teal-600',
  title: 'm-0 mx-2 line-clamp-2 text-base font-medium leading-5 text-denim-500 am-3xl:mx-0',
  thumbnailAndMetaRow: 'flex min-h-0 flex-1 flex-row items-center gap-6 am-3xl:items-start',
  mobileThumbnailWrap: 'h-26.5 w-36 shrink-0 overflow-hidden rounded-xl bg-gray-900 am-3xl:hidden',
  metaRow:
    'flex min-w-0 min-h-0 flex-1 flex-col items-start justify-center gap-3 text-sm leading-5 text-denim-800 am-3xl:flex-row am-3xl:flex-wrap am-3xl:items-center am-3xl:justify-start am-3xl:gap-4',
  metaItem: 'inline-flex min-w-0 items-center gap-2',
  cta: 'mt-2 w-full max-w-xs self-center rounded-2xl am-3xl:mt-auto am-3xl:w-44 am-3xl:max-w-none am-3xl:self-end am-3xl:rounded-3xl',
  ctaChevron: 'size-6 shrink-0',
} as const;
